<template>
  <div v-if="data !== undefined" class="accordion">
    <details class="accordion__inner">
      <summary class="accordion__title">
        {{ data.title }}
        <div class="accordion__icon">
          <Icon name="CircleChevronDownFilled" />
        </div>
      </summary>
      <div class="accordion__content">
        <Blocks :items="data.content.list" />
      </div>
    </details>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  data: any
}>()

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.accordion {
  @include tools.page-grid-columns;
  border-bottom: var(--border);

  &__title {
    @include tools.typo-heading-medium;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.666em;
    padding-bottom: 0.666em;
    cursor: pointer;
    @include tools.to(tools.$breakpoint--desktop) {
      padding-top: 1em;
      padding-bottom: 1em;
    }

    &::-webkit-details-marker {
      display: none;
    }
  }

  &__icon {
    transition: transform 0.2s ease-in-out;
  }

  &__content {
    display: flex;
    flex-direction: column;
    max-height: 0;
    gap: var(--grid-gutter);
    overflow: hidden;
    margin: var(--grid-gutter) 0;
  }

  & + & {
    margin-top: calc(var(--grid-gutter) * -1);
  }

  &__inner {
    &[open] {
      .accordion {
        &__content { // stylelint-disable-line
          max-height: 5000px;
          transition: max-height 1s ease-in-out;
        }

        &__icon { // stylelint-disable-line
          transform: rotate(180deg);
        }
      }
    }
  }
}

</style>
